import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    Grid,
    TextField,
    Button,
    Divider,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

const MblFile = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Shipment'tan gelen müşteri verisini al
    const incomingCustomer = location.state?.customer || "";

    const [customer, setCustomer] = useState(incomingCustomer);

    const handleSave = () => {
        // MBL'de yeniden düzenlenen customer bilgisini Shipment'a geri gönder
        navigate("/shipping-order/create-shipment", {
            state: { mblCustomer: customer }
        });
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <Grid container spacing={2} padding={3}>
                <Grid item xs={12}>
                    <h2>RMBL — Customer Information</h2>
                    <Divider sx={{ my: 2 }} />
                </Grid>

                {/* Customer Field */}
                <Grid item xs={12} md={6}>
                    <TextField
                        label="Customer"
                        fullWidth
                        value={customer}
                        onChange={(e) => setCustomer(e.target.value)}
                    />
                </Grid>

                {/* Buttons */}
                <Grid item xs={12} mt={2}>
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "#2196F3", color: "#FFF", marginRight: 10 }}
                        onClick={handleSave}
                    >
                        Save RMBL
                    </Button>

                    <Button
                        variant="contained"
                        style={{ backgroundColor: "#9E9E9E", color: "#FFF" }}
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </Button>
                </Grid>
            </Grid>

            <Footer />
        </DashboardLayout>
    );
};

export default MblFile;
